import { render, staticRenderFns } from "./ContactLayoutList.vue?vue&type=template&id=1bf5efa4&scoped=true"
import script from "./ContactLayoutList.vue?vue&type=script&lang=js"
export * from "./ContactLayoutList.vue?vue&type=script&lang=js"
import style0 from "./ContactLayoutList.vue?vue&type=style&index=0&id=1bf5efa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5efa4",
  null
  
)

export default component.exports